import useCategoryChoices from "./useCategoryChoices";

const ProductSectionController = ({ children }) => {
  const { categoryChoices, activeCategoryName, activeCategoryId } = useCategoryChoices();
  return children({ categoryChoices, activeCategoryName, activeCategoryId });
};

export default ProductSectionController;
